import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';

import { connect } from 'react-redux';
import queryString from 'query-string';

import { isEmpty } from 'lodash';

import BobPage from '../../../components/BobPage';
import TableContainer from './TableContainer';
import AddOrEditRole from './AddOrEditRole';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';

import { setPageTitle } from '../../../helpers/auth';

import * as CoreActions from '../../../actions/coreActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as RoleActions from '../../../actions/roleActions';

import classes from './RolesPage.module.css';

const RolesPage = ({
    activeNavCompany,
    companyInfo,
    fetchAllScopes,
    fetchServiceRequestList,
    fetchServiceManagementLookups,
    fetchTechniciansList,
    history,
    setProgressBarLoading,
    targetNavCompany,
    ...props
}) => {
    const [companyName, setCompanyName] = useState();
    const [selectedRole, setSelectedRole] = useState(null);
    const [roleAction, setRoleAction] = useState('');

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        if (activeNavCompany && activeNavCompany.name) {
            fetchAllScopes();
            if (roleAction === 'create') {
                setPageTitle(activeNavCompany.name, 'Add New Role');
            } else {
                setPageTitle(activeNavCompany.name, 'Roles');
            }
        }
    }, [activeNavCompany, roleAction]);

    useEffect(() => {
        const init = async () => {
            const { pathname } = history.location;

            if (!companyName) {
                setCompanyName(companyInfo.companyName);

                return;
            }

            const queryValuesString = queryString.stringify(queryValues);
            history.push(`${pathname}?${queryValuesString}`);
        };

        // If we have a companyId and no activeNavCompany that means we've (re)loaded, and
        // therefore need to reassemble the Company Overview page's data
        if (companyInfo.companyId && isEmpty(activeNavCompany)) init();
    }, [companyInfo]);

    useEffect(() => {
        async function init() {
        }

        init();
    }, [companyInfo.companyId]);

    const handleBackClick = () => {
        setRoleAction('');
        setSelectedRole(null);
    };

    return (
        <BobPage>
            <div className={classes.UserPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.HeaderPanel}>
                    {
                        selectedRole || roleAction === 'create' ?
                            <span>
                                <span
                                    className={classes.BackIcon}
                                    aria-hidden="true"
                                    role="button"
                                    tabIndex={0}
                                    onClick={() =>
                                        handleBackClick()
                                    }
                                >
                                    <i className="fas fa-chevron-left" />
                                </span>
                                { roleAction === 'create' ? `Add New Role` : `Edit Role` }
                            </span>  : 'Roles'
                    }
                </div>
                <div className={classes.DataPanel} />
                <div className={classes.TablePanel}>
                    {
                        selectedRole || roleAction === 'create' ?
                            <AddOrEditRole
                                isCreateRole={roleAction === 'create' ? true : false}
                                selectedRole={selectedRole}
                                onCancelClick={() => handleBackClick()}
                            /> :
                            <TableContainer
                                roleAction={roleAction}
                                setRoleAction={setRoleAction}
                                setSelectedRole={setSelectedRole}
                            />
                    }
                </div>
            </div>
        </BobPage>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
        companyInfo:      state.companyInfo
    };
};

const mapDispatchToProps = {
    ...CoreActions,
    ...DashboardActions,
    ...RoleActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RolesPage));
